import { Button, Tooltip } from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";
import { ComponentTitleCard } from "@pimo/pimo-components";

export type ReportTitleCardProps = {
  title: string;
  showReportButton: boolean;
  reportButtonLocked?: boolean;
  impactUpdatePath?: string;
};

export const ReportTitleCard: PimoReactComponent<
  ReportTitleCardProps,
  "edit-button:click"
> = ({ title, showReportButton, reportButtonLocked, fireEvent }) => {
  return (
    <ComponentTitleCard
      title={title}
      endSlot={
        showReportButton && (
          <ReportImpactButton
            reportButtonLocked={reportButtonLocked}
            onClick={() => fireEvent?.("edit-button:click")}
          />
        )
      }
    />
  );
};

export const ReportImpactButton = ({
  onClick,
  reportButtonLocked = false,
}: {
  onClick: () => void;
  reportButtonLocked?: boolean;
}) => (
  <Tooltip
    componentsProps={{
      tooltip: {
        sx: (theme) => ({
          bgcolor: "common.white",
          color: "black",
          border: "1px solid",
          borderColor: theme.palette.secondary.main,
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: 400,
          p: 1,
        }),
      },
    }}
    disableInteractive
    title={
      reportButtonLocked
        ? "Impact Reporting is currently locked by other users."
        : ""
    }
  >
    <span>
      <Button
        sx={{
          borderRadius: "4px",
          background: "#f86202",
          color: "#ffffff",
          border: "1px solid",
          marginLeft: "12px",
          textTransform: "none",
          "&:hover": {
            background: "#c44f04",
          },
        }}
        variant="outlined"
        type="button"
        disabled={reportButtonLocked}
        onClick={onClick}
      >
        {reportButtonLocked && "🔒"} Report Impact
      </Button>
    </span>
  </Tooltip>
);
